export const classNames = (...classNames: (string | null | undefined)[]) => classNames.filter(Boolean).join(' ');
